export default __webpack_public_path__ + "static/media/TopL_DarkBlue.628b8236.png";